import React from "react";
import {useDispatch} from "react-redux";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import {dismissSmsCheckResultModal} from "../actionCreators/myAccountAC";
import {ErrorWarning} from "../common/Icons";

const PhoneConfirmError = ({sms_code_state_message}) => {
    const dispatch = useDispatch();
    const dismiss = () => {
        dispatch(dismissSmsCheckResultModal());
    }

    return (
        <Modal
            show={true}
            size="md"
            centered
            onHide={dismiss}
            className="phone-confirm-modal rbg-popup-generic"
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay"
        >
            <Modal.Header className="rbg-popup-generic__header">
                <Button
                    className="rbg-popup-generic__close-icon"
                    onClick={dismiss}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close" />
                </Button>
            </Modal.Header>
            <Modal.Body className="rbg-popup-generic__body phone-confirm-modal__error-body">
                <div className="phone-confirm-modal__icon-container">
                    <ErrorWarning />
                </div>
                <div className="phone-confirm-modal__title phone-confirm-modal__title--error">
                    {sms_code_state_message}
                </div>
                <div className="phone-confirm-modal__text">
                    Please try again later
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PhoneConfirmError;